<template>
    <v-form @submit.prevent="addEditProject" ref="form">
        <v-card dense style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{mode}} Project</span>
                <v-spacer></v-spacer>
                <help-link appId="projects" pageId="creating-project" color="black"></help-link>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>  
                <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                    {{errorMessage}}
                </v-alert>    
                <v-layout row wrap class="form-container">  
                    <v-flex xs12 sm12>
                        <v-text-field label="Project Name" 
                            v-model="projectName" 
                            :rules="[rules.required, rules.max_100, rules.reserved_admin]" 
                            :disabled="disabled"
                            hint="Max 100 characters"
                            max="100"
                            append-icon="more_horiz"
                            @click:append="browseProjects"
                            @keyup="error=false" rows="1"></v-text-field>
                        <v-text-field 
                            label="Project Code" 
                            v-model="projectCode" 
                            :rules="[rules.required, rules.max_50]" 
                            :disabled="disabled"
                            hint="Max 50 characters"
                            append-icon="more_horiz"
                            @click:append="browseProjectCodes"
                            @keyup="error=false" 
                            ></v-text-field>
                        <v-text-field 
                            label="Client" 
                            v-model="client" 
                            :rules="[rules.required, rules.max_50]" 
                            :disabled="disabled"
                            hint="Max 50 characters"
                             append-icon="more_horiz"
                            @click:append="browseClients"
                            @keyup="error=false" 
                            ></v-text-field>
                        <v-textarea label="Description(optional)" 
                            v-model="projectDescription" 
                            :rules="[rules.max_1000]" 
                            :disabled="disabled"
                            hint="Max 1000 characters"
                            max="1000"
                            @keyup="error=false" rows="1"></v-textarea>
                    </v-flex>
                </v-layout> 
                <v-layout row wrap class="form-container">  
                    <v-flex xs12 sm6 style="padding-right:10px;">
                        <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="startDate" label="Target Start Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="startDate"  @input="menuStartDate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 style="padding-left:10px;">
                        <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="endDate" label="Target Completion Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="endDate" @input="menuEndDate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <!-- <v-select v-if="mode=='Edit'"
                        :items="status_list"
                        :rules="[rules.required]" 
                        label="Status"
                        v-model="status"               
                    ></v-select> -->
                    <!-- <v-text-field v-if="mode=='Edit'"
                            label="Percentage Complete" 
                            v-model="percentageComplete" 
                            :rules="[rules.numonly]" 
                            :disabled="disabled"
                            type="number" min="0" max="100" step="1" value="0"
                            @blur="formatHours"
                            ></v-text-field> -->
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading" style="color:white">Save</v-btn>
                <v-btn v-if="mode!='Edit'" @click="clearForm" :disabled="disabled">clear</v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="dialogCopy" width="650">   
            <copy-existing ref="copyExistingRef" @send="copyName" :dialogCopy.sync="dialogCopy"></copy-existing>
        </v-dialog>
    </v-form>
</template>
<script>
import projectsApi from '@/api/projects'
export default {
    name: 'AddEditProject',
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'copy-existing': () => import('@/components/Projects/CopyExistingName')
    },   
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,
            error: false,       
            status_list: ['Created','In Progress','Completed'],
            status: 'Created',
            percentageComplete: 0,
            dialogCopy: false,
            rules: {
                required: value => !!value || 'Required.',
                max_50: value => value.length <= 50 || "Max 50 characters",
                max_100: value => value.length <= 100 || "Max 100 characters",
                max_1000: value => value.length <= 1000 || "Max 1000 characters",
                reserved_admin: value => value.toLowerCase().trim() != 'admin' || "Admin is a reserved name. Append additional word or choose other name."
            },
            mode: '',
            projectId: '0',
            projectCode: '',
            client: '',
            projectName: '',
            projectKey: '',
            projectDescription: '',       
            teamId: 0, 
            addFrom: '',
            menuStartDate: false,
            startDate: null,
            menuEndDate: false,
            endDate: null,
            copy_list: null
        }
    },
    methods: {
        browseProjects() {
            const data = {
                type: 'project',
            }
            this.$refs.copyExistingRef.setData(data)
            this.dialogCopy = true
        },
        browseProjectCodes() {
            const data = {
                type: 'code'
            }
            this.$refs.copyExistingRef.setData(data)
            this.dialogCopy = true
        },
        browseClients() {
            const data = {
                type: 'client'
            }
            this.$refs.copyExistingRef.setData(data)
            this.dialogCopy = true
        },  
        copyName(data) {
            switch(data.type) {
                case 'project':
                    this.projectName = data.name
                    break;
                case 'code':
                    this.projectCode = data.name
                    break;
                case 'client':
                    this.client = data.name
                    break;
            }
        },
        closeDialog() {
            this.$emit('update:dialogProject', false)
            this.clearForm()
        },
        setProjectAdd(projects) {
            this.mode = 'Add'
            this.copy_list = projects
        },
        formatHours() {
            this.percentageComplete = this.percentageComplete > 100 ? 100 : this.percentageComplete
        },
        setData(data) {
            this.mode = 'Edit'
            this.projectKey = data.projectKey
            this.projectId = data.projectId
            this.projectCode = data.projectCode
            this.client = data.client
            this.projectName = data.projectName
            this.projectDescription = data.projectDescription
            this.startDate = data.startDate!=null? this.$moment(data.startDate).format('YYYY-MM-DD') : null
            this.endDate = data.endDate!=null? this.$moment(data.endDate).format('YYYY-MM-DD') : null
            this.status = data.status
            this.teamId = data.teamId
            this.copy_list = data.copy_list
        },
        async addEditProject() {         
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    var data = {
                        projectId: this.projectId,
                        projectCode: this.projectCode,
                        client: this.client,
                        projectName: this.projectName,
                        projectDescription: this.projectDescription,
                        startDate: this.startDate,
                        endDate: this.endDate,
                    }
                    var response = null
                    if (this.mode == 'Add')
                        response = await projectsApi.addProject(data)
                    else
                        response = await projectsApi.updateProject(data)

                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false                    
                        this.closeDialog()
                        this.$emit('send', response.data)
                    }
                }catch(error){
                    this.errorMessage = error
                    this.error = true
                }        
            }
        },        
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:0px 20px 0px 20px;
}
</style>